import script from "./QuickSearchImgWrapper.vue?vue&type=script&lang=js"
export * from "./QuickSearchImgWrapper.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__